module.exports = __webpack_public_path__ + "static/LevisLogo-792977999cefd2bc27c0fa8e48c0652e.png";